import { render, staticRenderFns } from "./srPhotoUploader.vue?vue&type=template&id=44c9f1d0&scoped=true"
import script from "./srPhotoUploader.vue?vue&type=script&lang=js"
export * from "./srPhotoUploader.vue?vue&type=script&lang=js"
import style0 from "./srPhotoUploader.vue?vue&type=style&index=0&id=44c9f1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c9f1d0",
  null
  
)

export default component.exports